function generateBackgroundStyles(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!props) {
    return "";
  }
  let backgroundStyles = (_a = props.background_color) == null ? void 0 : _a.hex;
  if (props.background_gradient_style === "linear") {
    backgroundStyles = `linear-gradient(${(_c = (_b = props.background_gradient_color) == null ? void 0 : _b.color1) == null ? void 0 : _c.hex},${(_e = (_d = props.background_gradient_color) == null ? void 0 : _d.color2) == null ? void 0 : _e.hex})`;
  } else if (props.background_gradient_style === "radial") {
    backgroundStyles = `radical-gradient(${(_g = (_f = props.background_gradient_color) == null ? void 0 : _f.color1) == null ? void 0 : _g.hex},${(_i = (_h = props.background_gradient_color) == null ? void 0 : _h.color2) == null ? void 0 : _i.hex})`;
  }
  return backgroundStyles || "";
}
function isMarkdownContent(content) {
  return "markdown_text" in content;
}
function isTileBlockContent(content) {
  return "tile_block" in content;
}
function isOverlayTileBlockContent(content) {
  return "overlay_tile_block" in content;
}
export {
  generateBackgroundStyles,
  isMarkdownContent,
  isOverlayTileBlockContent,
  isTileBlockContent
};
